import { useSessionStorage } from 'react-use';

import { type ApiResult } from '@/lib/api-helpers/endpoint-manager';
import {
  type SalesforceApplicantInfo,
  type SalesforcePublicResponse,
} from '@/lib/salesforce';

type ThankYouSession =
  | {
      applicantInfo: SalesforceApplicantInfo;
      userFirstName: string;
    }
  | undefined;

type SetterParams = {
  firstName: string;
  response: Response;
};

export const useThankYouSession = (): [
  ThankYouSession,
  (p: SetterParams) => Promise<void>
] => {
  const [thankYouSession, setThankYouSession] =
    useSessionStorage<ThankYouSession>('thankYouSession');

  // Define a different, public-facing setter that does some extra processing.
  const setThankYouSessionPublic = async ({
    response,
    firstName,
  }: SetterParams): Promise<void> => {
    const responseBody =
      (await response.json()) as ApiResult<SalesforcePublicResponse>;

    setThankYouSession({
      ...responseBody.result,
      userFirstName: firstName,
    });
  };

  return [thankYouSession, setThankYouSessionPublic];
};
